/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-12 14:58:11
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-13 15:11:08
 * @FilePath: /unifyxp-v2-store-portal/src/components/Link/GreenLink/index.tsx
 */
import React from 'react';
import Link from '../Link';
import css from './css.module.less';

const GreenLink = (props) => {
  const { className, children, ...rest } = props;
  return (
    <Link {...rest} className={`${css.link} ${className} `}>
      {children}
    </Link>
  );
};
const GreenHref = (props) => {
  const { className, children, disabled, ...rest } = props;
  return (
    <a
      {...rest}
      className={`${css.link} ${className} ${disabled ? css.disabled : ''}`}
      onClick={(e) => {
        if (disabled) {
          e.preventDefault();
        }
      }}>
      {children}
    </a>
  );
};
export { GreenHref };
export default GreenLink;
